import React from 'react';
import { useStyletron } from 'baseui';
import type { ModalOverrides } from 'baseui/modal';
import { Modal } from 'baseui/modal';
import { HeadingXSmall, ParagraphSmall } from 'baseui/typography';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { modalAtom } from '../atoms';
const modalOverrides = ({
  height,
  width
}: {
  height?: number;
  width?: number;
}): ModalOverrides => ({
  Root: {
    style: {
      position: 'absolute',
      height: height ? `${height}px` : 'auto',
      width: width ? `${width}px` : 'auto'
    }
  },
  Dialog: {
    style: ({
      $theme
    }) => ({
      padding: `${$theme.sizing.scale800} ${$theme.sizing.scale600} ${$theme.sizing.scale700}`
    })
  },
  Close: {
    style: ({
      $theme
    }) => ({
      top: $theme.sizing.scale800,
      right: $theme.sizing.scale600,
      margin: $theme.sizing.scale0
    })
  }
});
type Props = {
  modalRootRef: React.RefObject<HTMLDivElement>;
};
export const ReviewModal = ({
  modalRootRef
}: Props) => {
  const [_, theme] = useStyletron();
  const {
    title,
    description,
    component,
    isOpen
  } = useAtomValue(modalAtom);
  const resetModal = useResetAtom(modalAtom);
  const handleClose = () => resetModal();
  return <Modal isOpen={isOpen} onClose={handleClose} overrides={modalOverrides({
    // eslint-disable-next-line react-hooks/refs
    height: modalRootRef.current?.getBoundingClientRect().height,
    // eslint-disable-next-line react-hooks/refs
    width: modalRootRef.current?.getBoundingClientRect().width
  })} mountNode={modalRootRef.current ?? undefined /* eslint-disable-line react-hooks/refs */}>
      <HeadingXSmall $style={{
      letterSpacing: '0.25px',
      margin: 0
    }}>{title}</HeadingXSmall>
      <ParagraphSmall $style={{
      margin: 0,
      marginBottom: theme.sizing.scale600
    }}>
        {description}
      </ParagraphSmall>
      {component({
      onClose: handleClose
    })}
    </Modal>;
};